import Amount from '@/models/Shared/Amount';

export default class CreateRepaymentPlanRequest {
    reference: string;
    monthlyPaymentAmount: Amount = new Amount();
    totalRepaymentAmount: Amount = new Amount();
    planLength: string;
}